import { LengthUnit } from './enums/LengthUnit'
import DimensionsJson from './interfaces/DimensionsJson'

const CONVERSION_INCH_TO_MM = 25.4

export default class Dimensions {
  _height: number
  _width: number
  _depth: number
  _unit: LengthUnit

  constructor(height: number, width: number, depth: number, unit: LengthUnit) {
    this._height = height
    this._width = width
    this._depth = depth
    this._unit = unit
  }

  convertTo(value: number, unit: LengthUnit) {
    let valueInMillimeters = value
    switch (this._unit) {
      case LengthUnit.UNIT_CM:
        valueInMillimeters = value * 10
        break
      case LengthUnit.UNIT_INCH:
        valueInMillimeters = value * CONVERSION_INCH_TO_MM
        break
    }

    switch (unit) {
      case LengthUnit.UNIT_CM:
        return valueInMillimeters / 10
      case LengthUnit.UNIT_INCH:
        return valueInMillimeters / CONVERSION_INCH_TO_MM
      case LengthUnit.UNIT_MM:
      default:
        return valueInMillimeters
    }
  }

  height(locale: string, unit: LengthUnit): string {
    return this.format(locale, this._height, unit)
  }

  width(locale: string, unit: LengthUnit): string {
    return this.format(locale, this._width, unit)
  }

  depth(locale: string, unit: LengthUnit): string {
    return this.format(locale, this._depth, unit)
  }

  format(locale: string, value: number, unit: LengthUnit): string {
    const converted = this.convertTo(value, unit)

    return (
      Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
      }).format(converted) +
      ' ' +
      unit
    )
  }

  volume(unit: LengthUnit): number {
    const height = this.convertTo(this._height, unit)
    const width = this.convertTo(this._width, unit)
    const depth = this.convertTo(this._depth, unit)

    return height * width * depth
  }

  static fromJson(data: DimensionsJson) {
    return new this(data.height, data.width, data.depth, data.unit)
  }
}
